import { render, staticRenderFns } from "./SystemNotificationsContainer.vue?vue&type=template&id=ea6de3d8"
import script from "./SystemNotificationsContainer.vue?vue&type=script&lang=js"
export * from "./SystemNotificationsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports